module.exports = "//cdn.mxpnl.com/static/asset-cache/57d0dc92c36f08fd0acd8b0acbb6e2e3/iron/common/widgets/warning-hero/images/empty-funnels.svg";